import React from 'react';

import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core/styles';

import AlmeApp from './components/AlmeApp/AlmeApp';
import { createTheme } from './utils/PersonaUtils';
import { defaultTheme, defaultDarkTheme } from './models/AlmeTheme';

import { create } from 'jss';

import increaseSpecificity from '@alme/jss-increase-specificity-plugin';
import { LiveChatNotificationApiSettings } from '@alme/api-ts/LiveChat/LiveChatNotificationApiSettings';
import { AlmeIvaTypeProp } from './models/AlmeIvaTypeMapping';
import { PersonaState } from './models/AlmePersona';

export interface AppProps {
    personaState: PersonaState;
    apiSettings: LiveChatNotificationApiSettings;
    ivaType: AlmeIvaTypeProp;
    personaMapped: React.MutableRefObject<boolean>;
    isIvaProLaunch?: React.MutableRefObject<boolean>;
    clearAppData: () => void;
}

const jssPlugin = increaseSpecificity();

const jss = create({
    plugins: [...jssPreset().plugins, jssPlugin],
});

const VerintIVAUI: React.FC<AppProps> = (props: AppProps) => {

    const theme = props.personaState.themeMode === 'dark' ?
        createTheme([defaultDarkTheme, props.personaState.theme.darkTheme]) :
        createTheme([defaultTheme, props.personaState.theme.lightTheme]);

    return (
        <StylesProvider jss={jss}>
            <ThemeProvider theme={theme}>
                <AlmeApp ivaType={props.ivaType} almeConfig={props.personaState.config} apiSettings={props.apiSettings}
                    verintAccessKey={props.personaState.verintAccessKey} personaMapped={props.personaMapped}
                    isIvaProLaunch={props.isIvaProLaunch} clearAppData={props.clearAppData} />
            </ThemeProvider>
        </StylesProvider>
    );
};

export default VerintIVAUI;
